import SearchIcon from "../../../icons/SearchIcon"

const MixtapeSearchBar = ({ searchTerm, onSearchChange }) => {
  return (
    <form id="search" className="search mm-filter" onSubmit={(e) => e.preventDefault()}>
      <div id="mm-search-input">
        <div className="search-input-group">
          <div className="icon">
            <SearchIcon />
          </div>
          <label>Search</label>
          <input
            type="text"
            placeholder="Search for a playlist"
            aria-label="Enter search text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>
    </form>
  )
}


export default MixtapeSearchBar